import { ShieldCheck } from "lucide-react";

function positionClass(src: string) {
  if (src.includes("model-black")) return "privacy-face privacy-face-black";
  if (src.includes("model-lace")) return "privacy-face privacy-face-lace";
  return "privacy-face privacy-face-red";
}

export function PrivacyImage({
  src,
  alt,
  className = "",
  priority = false,
  showBadge = true,
}: {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
  showBadge?: boolean;
}) {
  return (
    <div className={`privacy-image ${className}`}>
      <img src={src} alt={alt} loading={priority ? "eager" : "lazy"} decoding="async" />
      <span className={positionClass(src)} aria-hidden="true" />
      <span className="privacy-shade" aria-hidden="true" />
      {showBadge && (
        <span className="privacy-badge">
          <ShieldCheck size={13} /> Identidad protegida
        </span>
      )}
    </div>
  );
}
